import { AddIconHome, IconAds, IconFunnel, IconOrders, IconPlusCircle } from "../assets/icons/icons";
import { decodeTokenService } from "../services/decodeTokenService";
import { dictionary, Language } from "../utils/dictionary";

const language = Language.SPANISH;
const uuidDataFake = decodeTokenService.getUserIdFromToken();

export const quickActions = [
    {
        title: dictionary["create-new-funnel"][language],
        icon: (active: boolean) => (
            <IconPlusCircle color={active ? "#ffffff" : "#6A6A6A"} width="30px" height="30px" />
        ),
        path: "/onboarding",
        // path: `/onboarding1?uuidData=${uuidDataFake}`,
    },
    {
        title: dictionary["create-new-home"][language],
        icon: (active: boolean) => (
            <AddIconHome color={active ? "#ffffff" : "#6A6A6A"} width="35px" height="35px" />
        ),
        path: "/onboarding/home",
        // path: "/onboarding1/home1",
    },
    // {
    //     title: dictionary["see-my-sales"][language],
    //     icon: (active: boolean) => (
    //         <IconOrders color={active ? "#ffffff" : "#6A6A6A"} width={"30px"} height={"30px"} />
    //     ),
    //     path: "/orders",
    // },
    {
        title: dictionary["see-my-funnels"][language],
        icon: (active: boolean) => (
            <IconFunnel color={active ? "#ffffff" : "#6A6A6A"} width={"30px"} height={"30px"} />
        ),
        path: "/funnels",
    },
    {
        title: dictionary["see-my-ads"][language],
        icon: (active: boolean) => (
            <IconAds color={active ? "#ffffff" : "#6A6A6A"} width={"30px"} height={"30px"} />
        ),
        path: "/ads",
    },
    // {
    //   title: "Administrar mis chats",
    //   icon: (
    //     <svg
    //       width="19"
    //       height="19"
    //       viewBox="0 0 19 19"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //       className="group-hover:fill-white fill-[#6A6A6A] transition-colors duration-200"
    //     >
    //       <path d="M16.625 0H2.375C1.03906 0 0 1.07617 0 2.375V13.0625C0 14.3984 1.03906 15.4375 2.375 15.4375H5.9375V18.5547C5.9375 18.8516 6.12305 19 6.38281 19C6.45703 19 6.53125 19 6.64258 18.9258L11.2812 15.4375H16.625C17.9238 15.4375 19 14.3984 19 13.0625V2.375C19 1.07617 17.9238 0 16.625 0ZM17.2188 13.0625C17.2188 13.3965 16.9219 13.6562 16.625 13.6562H10.6875L10.2051 14.0273L7.71875 15.8828V13.6562H2.375C2.04102 13.6562 1.78125 13.3965 1.78125 13.0625V2.375C1.78125 2.07812 2.04102 1.78125 2.375 1.78125H16.625C16.9219 1.78125 17.2188 2.07812 17.2188 2.375V13.0625ZM13.6562 5.04688H5.34375C5.00977 5.04688 4.75 5.34375 4.75 5.64062V6.23438C4.75 6.56836 5.00977 6.82812 5.34375 6.82812H13.6562C13.9531 6.82812 14.25 6.56836 14.25 6.23438V5.64062C14.25 5.34375 13.9531 5.04688 13.6562 5.04688ZM10.0938 8.60938H5.34375C5.00977 8.60938 4.75 8.90625 4.75 9.20312V9.79688C4.75 10.1309 5.00977 10.3906 5.34375 10.3906H10.0938C10.3906 10.3906 10.6875 10.1309 10.6875 9.79688V9.20312C10.6875 8.90625 10.3906 8.60938 10.0938 8.60938Z" />
    //     </svg>
    //   ),
    //   onClick: () => navigate("/chats"),
    // },
    // {
    //   title: "Ver mis métricas",
    //   icon: (
    //     <svg
    //       width="22"
    //       height="18"
    //       viewBox="0 0 22 18"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //       className="group-hover:fill-white fill-[#6A6A6A] transition-colors duration-200"
    //     >
    //       <path d="M15.0526 11.25H12.7368C12.0855 11.25 11.5789 11.7773 11.5789 12.375V16.875C11.5789 17.5078 12.0855 18 12.7368 18H15.0526C15.6678 18 16.2105 17.5078 16.2105 16.875V12.375C16.2105 11.7773 15.6678 11.25 15.0526 11.25ZM14.4737 16.3125H13.3158V12.9375H14.4737V16.3125ZM20.8421 6.75H18.5263C17.875 6.75 17.3684 7.27734 17.3684 7.875V16.875C17.3684 17.5078 17.875 18 18.5263 18H20.8421C21.4572 18 22 17.5078 22 16.875V7.875C22 7.27734 21.4572 6.75 20.8421 6.75ZM20.2632 16.3125H19.1053V8.4375H20.2632V16.3125ZM9.26316 6.75H6.94737C6.29605 6.75 5.78947 7.27734 5.78947 7.875V16.875C5.78947 17.5078 6.29605 18 6.94737 18H9.26316C9.87829 18 10.4211 17.5078 10.4211 16.875V7.875C10.4211 7.27734 9.87829 6.75 9.26316 6.75ZM8.68421 16.3125H7.52632V8.4375H8.68421V16.3125ZM3.47368 12.375H1.15789C0.506579 12.375 0 12.9023 0 13.5V16.875C0 17.5078 0.506579 18 1.15789 18H3.47368C4.08882 18 4.63158 17.5078 4.63158 16.875V13.5C4.63158 12.9023 4.08882 12.375 3.47368 12.375ZM2.89474 16.3125H1.73684V14.0625H2.89474V16.3125ZM2.31579 9C3.25658 9 4.05263 8.26172 4.05263 7.3125C4.05263 7.17188 4.01645 7.03125 3.98026 6.89062L7.63487 3.33984C7.77961 3.375 7.92434 3.375 8.10526 3.375C8.32237 3.375 8.50329 3.33984 8.7204 3.26953L12.1579 5.94141C12.1579 6.04688 12.1579 6.11719 12.1579 6.1875C12.1579 7.13672 12.9178 7.875 13.8947 7.875C14.8355 7.875 15.6316 7.13672 15.6316 6.1875C15.6316 6.11719 15.5954 6.04688 15.5954 5.94141L19.0329 3.26953C19.25 3.33984 19.4309 3.375 19.6842 3.375C20.625 3.375 21.4211 2.63672 21.4211 1.6875C21.4211 0.773438 20.625 0 19.6842 0C18.7072 0 17.9474 0.773438 17.9474 1.6875C17.9474 1.79297 17.9474 1.86328 17.9474 1.96875L14.5099 4.64062C14.2928 4.57031 14.1118 4.5 13.8586 4.5C13.6414 4.5 13.4605 4.57031 13.2434 4.64062L9.80592 1.96875C9.80592 1.86328 9.8421 1.79297 9.8421 1.6875C9.8421 0.773438 9.04605 0 8.10526 0C7.12829 0 6.36842 0.773438 6.36842 1.6875C6.36842 1.86328 6.36842 2.00391 6.40461 2.14453L2.75 5.69531C2.60526 5.66016 2.46053 5.625 2.31579 5.625C1.33882 5.625 0.578947 6.39844 0.578947 7.3125C0.578947 8.26172 1.33882 9 2.31579 9Z" />
    //     </svg>
    //   ),
    //   onClick: () => navigate("/metrics"),
    // },
    // {
    //   title: "Proyectar mis ventas",
    //   icon: (
    //     <svg
    //       width="15"
    //       height="18"
    //       viewBox="0 0 15 18"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //       className="group-hover:fill-white fill-[#6A6A6A] transition-colors duration-200"
    //     >
    //       <path d="M13.3929 0H1.60714C0.736607 0 0 0.808594 0 1.6875V16.3125C0 17.2266 0.736607 18 1.60714 18H13.3929C14.2299 18 15 17.2266 15 16.3125V1.6875C15 0.808594 14.2299 0 13.3929 0ZM13.3929 16.3125H1.60714V7.3125H13.3929V16.3125ZM13.3929 5.625H1.60714V1.6875H13.3929V5.625ZM3.61607 11.25H4.92188C5.12277 11.25 5.35714 11.0391 5.35714 10.8281V9.45703C5.35714 9.24609 5.12277 9 4.92188 9H3.61607C3.41518 9 3.21429 9.24609 3.21429 9.45703V10.8281C3.21429 11.0391 3.41518 11.25 3.61607 11.25ZM10.0446 14.625H11.3504C11.5513 14.625 11.7857 14.4141 11.7857 14.2031V9.45703C11.7857 9.24609 11.5513 9 11.3504 9H10.0446C9.84375 9 9.64286 9.24609 9.64286 9.45703V14.2031C9.64286 14.4141 9.84375 14.625 10.0446 14.625ZM3.61607 14.625H4.92188C5.12277 14.625 5.35714 14.4141 5.35714 14.2031V12.832C5.35714 12.6211 5.12277 12.375 4.92188 12.375H3.61607C3.41518 12.375 3.21429 12.6211 3.21429 12.832V14.2031C3.21429 14.4141 3.41518 14.625 3.61607 14.625ZM6.83036 11.25H8.13616C8.33705 11.25 8.57143 11.0391 8.57143 10.8281V9.45703C8.57143 9.24609 8.33705 9 8.13616 9H6.83036C6.62946 9 6.42857 9.24609 6.42857 9.45703V10.8281C6.42857 11.0391 6.62946 11.25 6.83036 11.25ZM6.83036 14.625H8.13616C8.33705 14.625 8.57143 14.4141 8.57143 14.2031V12.832C8.57143 12.6211 8.33705 12.375 8.13616 12.375H6.83036C6.62946 12.375 6.42857 12.6211 6.42857 12.832V14.2031C6.42857 14.4141 6.62946 14.625 6.83036 14.625Z" />
    //     </svg>
    //   ),
    //   onClick: () => navigate("/calculator"),
    // },
    // {
    //   title: "Aprender a vender",
    //   icon: (
    //     <svg
    //       width="21"
    //       height="18"
    //       viewBox="0 0 21 18"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //       className="group-hover:fill-white fill-[#6A6A6A] transition-colors duration-200"
    //     >
    //       <g clip-path="url(#clip0_666_9587)">
    //         <path d="M9.09838 12.5144C8.53825 13.0577 7.74956 13.8188 6.95774 14.5653C4.21094 11.1657 2.51652 7.97467 1.51953 5.6792H13.7752C13.3173 6.57095 12.8242 7.43977 12.2961 8.28414H6.18932C6.9671 9.60304 7.92508 11.0366 9.0976 12.5144H9.09838Z" />
    //         <path d="M16.8174 2.51318L16.8027 2.52605C16.8027 2.52605 16.8044 2.52203 16.8052 2.51962L16.8174 2.51318Z" />
    //         <path d="M13.7976 5.67676H4.09766V5.67837H13.7976V5.67676Z" />
    //         <path d="M14.4213 3.9222C14.4072 3.95353 14.3932 3.98409 14.3791 4.01542H1.60002C1.14833 4.01542 0.745793 3.7304 0.605372 3.30936C0.381478 2.63921 0.280843 2.23498 0.26524 2.1685L0.272261 2.16697C0.138861 1.69168 0 1.18659 0 1.18659H1.89413V1.18506H13.9922L14.3518 1.86667C14.6896 2.50625 14.7177 3.26275 14.4213 3.9222Z" />
    //         <path d="M20.9995 3.46765L19.9581 4.01477L19.6359 3.42562C19.5891 3.55094 19.5423 3.67397 19.4939 3.79699C17.9867 7.70173 16.0973 10.8293 14.2741 13.2478C13.1625 14.7234 12.0773 15.9345 11.1178 16.8981L10.0194 18L8.95761 16.8645C8.63231 16.516 8.31714 16.1676 8.01367 15.8214C9.02002 14.9098 10.2479 13.6643 11.4072 12.1345C11.4111 12.1291 11.415 12.1246 11.4189 12.1192C11.5702 11.9282 11.7208 11.7318 11.8729 11.5308C13.5478 9.311 15.2875 6.43479 16.6847 2.83724C16.7237 2.7379 16.7619 2.63704 16.7994 2.53617C16.8009 2.53235 16.8017 2.52929 16.8033 2.52547L16.8173 2.51325L16.8056 2.51936L16.1183 2.88079L15.5598 1.86067L17.7347 0.718288L19.0999 0L20.9995 3.46765Z" />
    //       </g>
    //       <defs>
    //         <clipPath id="clip0_666_9587">
    //           <rect width="21" height="18" fill="white" />
    //         </clipPath>
    //       </defs>
    //     </svg>
    //   ),
    //   onClick: () => navigate("/learning"),
    // },
];